// import { Link } from "react-router-dom";
// import { useState } from "react";
// import ConfirmModal from "components/common/ConfirmModal";
// import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";
// import { saveAs } from "file-saver";
// import { getImageUrl } from "utils/imageHelper";
// import ImageViewer from "components/common/ImageViewer";

// export default function EventsTable({ data = [], onDelete, onRefresh }) {
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [viewerOpen, setViewerOpen] = useState(false);
//   const [viewerSrc, setViewerSrc] = useState(null);

//   const [viewerData, setViewerData] = useState(null);


//     const formatDateTime = (iso) => {
//       if (!iso) return "-";

//       const d = new Date(iso);

//       return d.toLocaleString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//         hour12: false,
//       });
//     };

//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await onDelete(deleteId);
//       setDeleteId(null);
//       onRefresh();
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//         <table className="w-full text-left">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Event Image
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Event Name
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Start Date
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 End Date
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Status
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600 text-right">
//                 Actions
//               </th>
//             </tr>
//           </thead>

//           <tbody className="divide-y">
//             {data.length === 0 ? (
//               <tr>
//                 <td
//                   colSpan="5"
//                   className="px-6 py-10 text-center text-sm text-gray-500"
//                 >
//                   No events found
//                 </td>
//               </tr>
//             ) : (
//               data.map(item => (
//                 <tr
//                   key={item._id}
//                   className="hover:bg-gray-50 transition"
//                 >

//                   <td className="px-6 py-4">
//   {(() => {
//     let mediaPath = null;
//     let mediaType = null;

//     const defaultMedia = item.default_media;

//     if (defaultMedia) {
//       if (defaultMedia.type === "image") {
//         mediaPath = defaultMedia.value;
//         mediaType = "image";
//       }

//       if (defaultMedia.type === "video") {
//         mediaPath = defaultMedia.value;
//         mediaType = "video";
//       }
//     }

//     if (!mediaPath) {
//       if (item.eventImage?.length > 0) {
//         mediaPath = item.eventImage[0];
//         mediaType = "image";
//       } else if (item.eventVideo?.length > 0) {
//         mediaPath = item.eventVideo[0];
//         mediaType = "video";
//       }
//     }

//     if (!mediaPath) {
//       return (
//         <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center text-xs text-gray-400">
//           no media
//         </div>
//       );
//     }

//     const fullUrl = getImageUrl(mediaPath);

//     return mediaType === "image" ? (
//       <img
//         src={fullUrl}
//         alt={item.event_name}
//         className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
//         onClick={() => {
//           setViewerSrc(fullUrl);
//           setViewerData({ url: fullUrl, type: "image" });
//           setViewerOpen(true);
//         }}
//       />
//     ) : (
//       <video
//         src={fullUrl}
//         className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
//         onClick={() => {
//           setViewerSrc(fullUrl);
//           setViewerData({ url: fullUrl, type: "video" });
//           setViewerOpen(true);
//         }}
//       />
//     );
//   })()}
// </td>




//                   <td className="px-6 py-4 font-medium text-gray-800">
//                     {item.event_name}
//                   </td>

//                   <td className="px-6 py-4 text-gray-600">
//                     {formatDateTime(item.event_dates?.[0]?.from_date)}
//                   </td>

//                   <td className="px-6 py-4 text-gray-600">
//                     {formatDateTime(item.event_dates?.[0]?.to_date)}
//                   </td>


//                   <td className="px-6 py-4">
//                     <span
//                       className={`rounded-full px-3 py-1 text-xs font-semibold ${
//                         item.status === "active"
//                           ? "bg-green-100 text-green-700"
//                           : "bg-gray-200 text-gray-600"
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                   </td>


//                   <td className="px-6 py-4">
//                     <div className="flex justify-end gap-3">
//                       <Link
//                         to={`/admin/events/view/${item._id}`}
//                         title="View"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-500"
//                       >
//                         <MdVisibility size={18} />
//                       </Link>

//                       <Link
//                         to={`/admin/events/edit/${item._id}`}
//                         title="Edit"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//                       >
//                         <MdEdit size={18} />
//                       </Link>

//                       <button
//                         title="Delete"
//                         onClick={() => setDeleteId(item._id)}
//                         className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
//                       >
//                         <MdDelete size={18} />
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmModal
//         open={Boolean(deleteId)}
//         title="Delete Event"
//         message="This action cannot be undone. Do you want to continue?"
//         confirmText="Delete"
//         loading={loading}
//         onConfirm={handleDelete}
//         onCancel={() => setDeleteId(null)}
//       />

//       <ImageViewer
//         open={viewerOpen}
//         onClose={() => setViewerOpen(false)}
//         src={viewerData?.url}
//         type={viewerData?.type}
//       />

//     </>
//   );
// }

import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdMoreVert, MdVisibility, MdEdit, MdDelete } from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";

export default function EventsTable({
  data = [],
  startIndex = 0,
  onDelete,
  onRefresh,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  viewButton,
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerData, setViewerData] = useState(null);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(rowId);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      return iso;
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              <th className="w-12 text-center">
                <input
                  type="checkbox"
                  className="table-checkbox"
                  onChange={onSelectAll}
                  checked={
                    data.length > 0 && selectedRows.length === data.length
                  }
                />
              </th>
              <th>Media</th>
              <th>Event Name</th>
              {/* <th>Category</th>
              <th>Location</th> */}
              <th>Start Date</th>
              <th>End Date</th>
              <th className="text-center">Status</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="9"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No events found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowId = item._id || index;
                const isChecked = selectedRows.includes(rowId);
                const isMenuOpen = openDropdownId === rowId;
                const isActive =
                  item.status?.toLowerCase() === "active" ||
                  item.status === true;

                // Derive display image/video
                const firstImg = item.eventImage?.[0];
                const firstVid = item.eventVideo?.[0];
                const mediaPath = firstImg || firstVid;
                const isVideo = !firstImg && Boolean(firstVid);

                // Date ranges
                const firstDateSlot = item.event_dates?.[0] || {};

                return (
                  <tr key={rowId} className="custom-table-row">
                    {/* Checkbox */}
                    <td className="custom-table-cell text-center">
                      <input
                        type="checkbox"
                        className="table-checkbox"
                        checked={isChecked}
                        onChange={() => onSelectRow && onSelectRow(rowId)}
                      />
                    </td>

                    {/* Media Thumbnail */}
                    <td className="custom-table-cell">
                      {mediaPath ? (
                        isVideo ? (
                          <video
                            src={getImageUrl(mediaPath)}
                            className="table-logo cursor-pointer"
                            onClick={() => {
                              setViewerData({
                                url: getImageUrl(mediaPath),
                                type: "video",
                              });
                              setViewerOpen(true);
                            }}
                          />
                        ) : (
                          <img
                            src={getImageUrl(mediaPath)}
                            alt={item.event_name}
                            className="table-logo cursor-pointer"
                            onClick={() => {
                              setViewerData({
                                url: getImageUrl(mediaPath),
                                type: "image",
                              });
                              setViewerOpen(true);
                            }}
                          />
                        )
                      ) : (
                        <span style={{ fontSize: "10px", color: "#d1d5db" }}>
                          No media
                        </span>
                      )}
                    </td>

                    {/* Event Name */}
                    <td className="custom-table-cell font-medium">
                      {item.event_name || "N/A"}
                    </td>

                    {/* Category */}
                    {/* <td className="custom-table-cell">
                      {item.event_category_id?.title || "—"}
                    </td> */}

                    {/* Location */}
                    {/* <td className="custom-table-cell">
                      {item.location || "—"}
                    </td> */}

                    {/* Start Date */}
                    <td className="custom-table-cell">
                      {formatDateTime(
                        firstDateSlot.from_date || item.from_date
                      )}
                    </td>

                    {/* End Date */}
                    <td className="custom-table-cell">
                      {formatDateTime(firstDateSlot.to_date || item.to_date)}
                    </td>

                    {/* Status Badge */}
                    <td className="custom-table-cell text-center">
                      <span
                        className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
                          isActive
                            ? "bg-[#dcfce7] text-[#16a34a]"
                            : "bg-[#f1f5f9] text-[#64748b]"
                        }`}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>
                    </td>

                    {/* Actions Menu */}
                    <td className="custom-table-cell relative text-center">
                      <button
                        onClick={(e) => handleToggleMenu(e, rowId)}
                        className="action-menu-btn"
                      >
                        <MdMoreVert className="text-lg" />
                      </button>

                      {isMenuOpen && (
                        <div
                          ref={dropdownRef}
                          className={`action-dropdown-menu ${
                            openUpward ? "menu-bottom" : "menu-top"
                          }`}
                        >
                          <button
                            onClick={() => {
                              if (viewButton) viewButton(item);
                              setOpenDropdownId(null);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdVisibility className="text-base" />
                            View
                          </button>

                          <div className="action-dropdown-divider" />

                          <Link
                            to={`/admin/events/edit/${item._id}`}
                            onClick={() => setOpenDropdownId(null)}
                            className="action-dropdown-item"
                          >
                            <MdEdit className="text-base" />
                            Edit
                          </Link>

                          <div className="action-dropdown-divider" />

                          <button
                            onClick={() => {
                              setDeleteId(item._id);
                              setOpenDropdownId(null);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdDelete className="text-base" />
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Event"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />

      {/* Media Viewer Modal */}
      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerData?.url}
        type={viewerData?.type}
      />
    </>
  );
}